import OServicesModalInner from './o-services-modal-inner';

export default OServicesModalInner;